import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { onError } from 'apollo-link-error'
import { ApolloLink, Observable } from 'apollo-link'
import { path } from 'ramda'
import { authorizeUser } from 'actions'
import { createUploadLink } from 'apollo-upload-client'
import debug from 'debug'

const graphqlClientDebug = debug('linkgua:network:graphqlClient')

let graphqlClient = null
export const configureGraphqlClient = (store) => {

  let accessToken = null

  const unsubscribe = store.subscribe(() => {
    const state = store.getState()
    accessToken = path(['auth', 'authUser', 'accessToken'], state)
    return {accessToken}
  })

  const cache = new InMemoryCache()

  const request = async (operation) => {
    operation.setContext({
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
  }

  // note: 'fetchPolicy' *cannot* be set to 'no-cache' because that breaks internals inside form component
  const defaultOptions = {
    watchQuery: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all'
    }
  }

  const requestLink = new ApolloLink((operation, forward) =>
    new Observable(observer => {
      let handle
      Promise.resolve(operation)
        .then(oper => request(oper))
        .then(() => {
          handle = forward(operation).subscribe({
            next: observer.next.bind(observer),
            error: observer.error.bind(observer),
            complete: observer.complete.bind(observer),
          })
        })
        .catch(observer.error.bind(observer))

      return () => {
        if (handle) handle.unsubscribe()
      }
    })
  )

  graphqlClient = new ApolloClient({
    defaultOptions: defaultOptions,
    link: ApolloLink.from([
      onError(({graphQLErrors, networkError}) => {
        if (networkError && networkError.statusCode === 401) {
          graphqlClientDebug('Received 401, initiating authorization')
          store.dispatch(authorizeUser())
        } else if (graphQLErrors) {
          for (let err of graphQLErrors) {
            if (err.extensions.code === 'UNAUTHENTICATED') {
              graphqlClientDebug('Received UNAUTHENTICATED GraphQLError, initiating authorization')
              store.dispatch(authorizeUser())
              break
            }
          }
        }
      }),
      requestLink,
      createUploadLink({
        uri: `${process.env.LINKGUA_API_URL}/data`,
        credentials: 'same-origin'
      })
    ]),
    cache
  })
}

export const getConfiguredClient = () => {
  if (!graphqlClient) throw new Error('Apollo client not configured')
  return graphqlClient
}



// WEBPACK FOOTER //
// ./util/graphqlClient.js